
import * as crudModels from "~/models";
import {
  applyCollectionQueryState,
  readCollectionQueryState,
} from "../../filters/collectionQueryState";
import {
  readStickyFilterState,
  writeStickyFilterState,
} from "../../filters/stickyFilters";

const resetQuery = (vm) => {
  vm.layout.collection.clearFiltersExcept([...vm.queryStringFilters]);
  const dynamicFilters = vm.layout.collection.dynamicFilterController;
  if (!vm.queryStringFilters.includes(dynamicFilters.queryName)) {
    dynamicFilters.clear();
  }
  vm.layout.collection.resetQueryOptionsExcept(
    vm.currentOptionKeys.map((queryName) => queryName.substr(1))
  );
  vm.layout.collection.applyStagedFilters();
};

export default {
  data() {
    const layout = crudModels[this.modelName].getCollectionLayout(
      this.layoutId
    );

    return {
      listTitle: crudModels[this.modelName].listTitle,
      icon: crudModels[this.modelName].icon,
      layout,
      stickyReady: false,
    };
  },
  props: {
    modelName: {
      type: String,
      required: true,
    },
    layoutId: {
      type: String,
    },
  },
  computed: {
    currentOptionKeys() {
      return Object.keys(this.$route.query).filter(
        (queryName) => queryName.indexOf("_") === 0
      );
    },
    queryStringFilters() {
      return Object.keys(this.$route.query)
        .filter((queryName) => queryName.indexOf("_") !== 0)
        .filter((queryName) => this.layout.collection.getFilter(queryName));
    },
    filterSetScope() {
      return `${this.layout.modelType.typeSlug}:${this.layout.id}`;
    },
    stickyEnabled() {
      return this.layout.stickyFilters;
    },
  },
  watch: {
    "layout.collection.filterQueryValues": {
      handler() {
        const setFilters = _.pickBy(
          this.layout.collection.filterQueryValues,
          (value) => value || value === 0
        );

        const queryFiltersString = new URLSearchParams(setFilters).toString();
        const existingQueryOptionsString = new URLSearchParams(
          _.pick(this.$route.query, this.currentOptionKeys)
        ).toString();

        const allQueryStrings = [
          queryFiltersString,
          existingQueryOptionsString,
        ].filter((s) => s.length > 0);

        const newStateUrl =
          this.$route.path +
          (allQueryStrings.length > 0 ? "?" + allQueryStrings.join("&") : "");

        const curUrl = new URL(document.location.href);
        const curStateUrl = curUrl.pathname + curUrl.search;

        if (curStateUrl != newStateUrl) {
          history.pushState({}, "", newStateUrl);
        }

        this.persistStickyState();
      },
    },
    "layout.collection.remoteQueryOptions": {
      handler() {
        this.persistStickyState();
      },
      deep: true,
    },
    "$route.query": {
      handler() {
        applyCollectionQueryState(
          this.layout.collection,
          this.$route.query
        );
      },
      immediate: true,
    },
  },
  methods: {
    persistStickyState() {
      if (!this.stickyEnabled || !this.stickyReady) return;

      writeStickyFilterState(
        this.filterSetScope,
        this.layout.collection.hasMeaningfulQueryState
          ? readCollectionQueryState(this.layout.collection)
          : {}
      );
    },
    loadQueryState(state) {
      this.layout.collection.clearFiltersExcept([]);
      this.layout.collection.dynamicFilterController.clear();
      this.layout.collection.resetQueryOptionsExcept([]);
      this.layout.collection.applyStagedFilters();

      return this.$router
        .replace({
          path: this.$route.path,
          query: { ...state },
        })
        .catch((error) => {
          if (error.name !== "NavigationDuplicated") throw error;
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    setTimeout(() => resetQuery(this), 100);
    next();
  },
  mounted() {
    resetQuery(this);

    const hasIncomingCollectionState = Object.keys(this.$route.query).some(
      (key) =>
        key.indexOf("_") === 0 || this.layout.collection.getFilter(key)
    );

    if (!this.stickyEnabled) return;

    const stickyState = hasIncomingCollectionState
      ? null
      : readStickyFilterState(this.filterSetScope);

    if (stickyState) {
      this.loadQueryState(stickyState).finally(() => {
        setTimeout(() => {
          this.stickyReady = true;
        }, 150);
      });
    } else {
      this.stickyReady = true;
    }
  },
};
